<template>
  <div class="content base">
    <Form ref="formInline" :model="formData" class="page-form" :label-width="100">
      <FormItem label="公司简称" prop="name">
        <span>{{ formData.name || '--' }}</span>
      </FormItem>
      <FormItem label="公司全称" prop="fullName">
        <span>{{ formData.fullName || '--' }}</span>
      </FormItem>
      <FormItem label="所属地区" prop="province" style="height: 32px">
        {{ formData.province | filterVal(provinceList, 'province', 'label') }}
      </FormItem>
      <FormItem label="保司邮箱" prop="email">
        <span>{{ formData.email || '--' }}</span>
      </FormItem>
      <FormItem label="保司电话" prop="phone">
        <span>{{ formData.phone || '--' }}</span>
      </FormItem>
      <FormItem label="保司地址" prop="address">
        <span>{{ formData.address || '--' }}</span>
      </FormItem>
      <FormItem label="logo" prop="logo">
        <img class="logo" :src="formData.logo" alt="" srcset="" />
      </FormItem>
      <FormItem label="保司描述" prop="description">
        <span>{{ formData.description || '--' }}</span>
      </FormItem>
      <br />
      <FormItem label="保司亮点" prop="feature">
        <Row v-for="(item, index) in formData.feature" :key="index">
          <Row
            ><Col
              ><a @click="toUrl(item.path)">{{ item.fileName }}</a></Col
            ></Row
          >
        </Row>
      </FormItem>
      <FormItem label="官方文件" prop="intro">
        <Row v-for="(item, index) in formData.intro" :key="index">
          <Row
            ><Col
              ><a @click="toUrl(item.path)">{{ item.fileName }}</a></Col
            ></Row
          >
        </Row>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import uploadNew from '@/components/commons/uploadNew2';
import topSearchForm from '@/components/commons/topSearchForm';
export default {
  components: { uploadNew, topSearchForm },
  data: () => ({
    tabActive: '1',
    provinceList: [
      {
        label: '中国香港',
        province: '1'
      },
      {
        label: '中国澳门',
        province: '2'
      }
    ],
    formData: {
      id: '',
      name: '',
      fullName: '',
      code: '',
      email: '',
      phone: '',
      province: '',
      address: '',
      remark_: '',
      intro: [],
      logo: '',
      usdToHkdExchangeRate: '',
      hkdToRmbExchangeRate: '',
      description: '',
      feature: [],
      sortNum: ''
    }
  }),
  created() { },
  methods: {
    init(item = {}) {
      this.$refs.formInline && this.$refs.formInline.resetFields();
      if (item.id) {
        this.formData.id = item.id;
        this.getDetail();
      }
    },
    //基本信息
    getDetail() {
      this.$http({
        url: `/buz/insuranceCompany/read/detail`,
        type: 'GET',
        data: {
          id: this.formData.id
        }
      }).then(res => {
        if (res.data.intro) {
          res.data.intro = JSON.parse(res.data.intro || '[]');
        }
        if (res.data.intro) {
          res.data.feature = JSON.parse(res.data.feature || '[]');
        }
        if (res.data.hkdToRmbExchangeRate) {
          res.data.hkdToRmbExchangeRate = JSON.stringify(res.data.hkdToRmbExchangeRate);
        }
        if (res.data.usdToHkdExchangeRate) {
          res.data.usdToHkdExchangeRate = JSON.stringify(res.data.usdToHkdExchangeRate);
        }
        this.formData = res.data;
      });
    },

    toUrl(url) {
      window.open(url);
    }
  }
};
</script>
    <style lang='scss' scoped>
@import './base';
.logo {
  max-width: 200px;
  max-height: 200px;
}
</style>